/* This example requires Tailwind CSS v2.0+ */
import React, { Fragment } from "react"
import { Listbox, Transition } from "@headlessui/react"
import { ChevronDownIcon as SelectorIcon } from "@heroicons/react/24/solid"
import { useField } from "formik"
import classNames from "classnames"

const data = ["No Data found"]

export default function DropDown({
	label,
	values,
	name,
	placeholder,
	isOrganisationSize,
	valueChange,
}) {
	const [field, meta, helper] = useField(name)

	if (!values) {
		values = data
	}

	// useEffect(() => {
	//   helper.setValue(null);
	// }, [values]);

	return (
		<Listbox
			value={field.value}
			onChange={(value) => {
				helper.setValue(value)
				isOrganisationSize && valueChange(value)
			}}
		>
			<Listbox.Label className="block text-sm font-medium text-gray-700">{label}</Listbox.Label>
			<div className="mt-1 relative">
				<Listbox.Button className="relative w-full bg-white border border-gray-300 rounded-md shadow-sm pl-3 pr-10 py-2 text-left cursor-default focus:outline-none focus:ring-1 focus:ring-primary-500 focus:border-primary-500 sm:text-sm">
					<span className={`block truncate ${!field.value ? "text-gray-400" : ""}`}>
						{field.value ? field.value : placeholder || "Select an option"}
					</span>
					<span className="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
						<SelectorIcon
							className="h-5 w-5 text-gray-400"
							aria-hidden="true"
						/>
					</span>
				</Listbox.Button>

				<Transition
					as={Fragment}
					leave="transition ease-in duration-100"
					leaveFrom="opacity-100"
					leaveTo="opacity-0"
				>
					<Listbox.Options className="absolute z-10 mt-1 w-full bg-white shadow-lg max-h-60 rounded-md py-1 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm">
						{values &&
							values.map((item, idx) => (
								<Listbox.Option
									className={({ active }) =>
										classNames(
											active ? "bg-primary-300" : "text-gray-900",
											"cursor-default relative py-2 pl-3 pr-9"
										)
									}
									key={idx}
									value={item}
								>
									{({ active }) => (
										<>
											<span
												className={classNames(
													field.value ? "font-normal" : "font-normal",
													"block truncate"
												)}
											>
												{item}
											</span>

											{field.value ? (
												<span
													className={classNames(
														active ? "text-white" : "font-semibold",
														"absolute inset-y-0 right-0 flex items-center pr-4"
													)}
												></span>
											) : null}
										</>
									)}
								</Listbox.Option>
							))}
					</Listbox.Options>
				</Transition>
			</div>
			{meta.touched && meta.error && <p className="text-sm text-red-600 mt-1">{meta.error}</p>}
		</Listbox>
	)
}
